<template>
<group-card title="Warranty Income">
  <template slot="actions">
    <loading-icon-button
      @click="getWarrantyBillings()"
      tooltip="Fetch Warranty Deal Billings"
    >
      get_app
    </loading-icon-button>
  </template>
  <v-data-table
    :headers="warranty_billing_headers"
    :items="warranty_billings"
    v-model="localSelectedWarrantyBills"
    item-key="id"
    show-select
    :items-per-page="10"
    class="elevation-0 warranty-deal-table"
    :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'first_page',
      lastIcon: 'last_page',
      prevIcon: 'skip_previous',
      nextIcon: 'skip_next',
      itemsPerPageOptions: [10, -1],
      itemsPerPageText: '',
    }"
    :loading="loading"
    :loading-text="loading_text"
  >
    <template v-slot:item.created_date="{ item }">
      {{ item.created_date | datetime }}
    </template>
    <template v-slot:item.amount="{ item }">
      {{ item.amount | currency }}
    </template>
    <template v-slot:item.deleted_at="{ item }">
      {{ item.deleted_at | datetime }}
    </template>
  </v-data-table>
</group-card>
</template>
<script>

import { GroupCard } from "@/components";
import { mapGetters } from "vuex";
import LoadingIconButton from "@/components/LoadingIconButton";
import filters from "@/components/utils/filters";
import AlertDialog from "../components/Dialogs/AlertDialog.vue";

export default {
  components: {
    GroupCard,
    LoadingIconButton,
    AlertDialog,
  },
  filters: {
    ...filters,
  },
  props: {
    selectedWarrantyBills: {
      type: Array,
      default: () => [],
    },
    year: {
      type: Number,
      default: null,
    },
    month: {
      type: Number,
      default: null,
    },
    pod: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      warranty_billing_headers: [
        {
          text: "",
          align: "start",
          value: "selected_bills",
        },
        {
          text: "Billed At",
          value: "created_date",
        },
        {
          text: "Bill ID",
          sortable: true,
          value: "id",
        },
        {
          text: "Loan Application",
          value: "application_id",
        },
        {
          text: "Customer Name",
          value: "customer_name",
        },
        {
          text: "Billed Against",
          value: "name",
        },
        {
          text: "User Pod",
          value: "user_pod",
        },
        {
          text: "Product",
          value: "billing_name",
        },
        {
          text: "Amount",
          value: "amount",
        },
        {
          text: "Sent To Xero Date",
          value: "deleted_at",
        }
      ],
      loading: false,
    }
  },
  methods: {
    async getWarrantyBillings () {
      // SDB-1020 move warranty deals to rcti table
      return;
      if (!this.year || !this.month || this.pod === '') {
        this.$modal.show(AlertDialog, {
          title: "Failed",
          message: "Please select year ,month and pod.",
        })
      }
      try {
        const response = await this.$store.dispatch('get_warranty_billings', {
          selected_year: this.year,
          selected_month: this.month,
          selected_pod: this.pod,
        })
        if (!response) {
          this.$modal.show(AlertDialog, {
            title: "Failed",
            message: "Failed to retrieve warranty deal billing.",
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  computed: {
    ...mapGetters({
      options: "options",
      warranty_billings: "warranty_billings",
    }),
    loading_text () {
      return this.warranty_billings && this.warranty_billings.length === 0 ? 'No Record' : 'Loading...';
    },
    localSelectedWarrantyBills: {
      get() {
        return this.selectedWarrantyBills;
      },
      set(newVal) {
        this.$emit('update:selectedWarrantyBills', newVal);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.warranty-deal-table::v-deep th,
.warranty-deal-table::v-deep td {
  text-align: left; /* Align the content to the center */
}
</style>